import { useRef, useState } from "react";
import { ChangelogPopover } from "./ChangelogPopover";

export function Footer() {
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);

  return (
    <footer className="app-footer">
      <button
        ref={btnRef}
        type="button"
        className="app-footer-version"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        AI Navigator v{__APP_VERSION__}
      </button>
      <span className="app-footer-org">Brookfield Residential · Technology</span>
      <ChangelogPopover
        open={open}
        anchor={btnRef.current}
        onClose={() => setOpen(false)}
      />
    </footer>
  );
}
